import { getCookie, setCookie } from "./cookies";

export function forms() {
  
  
  $(document).ready(function () {
    
    $('.webinar_form [type="submit"]').click(function(e) {
      
      e.preventDefault();
      
      var $this = $(this).closest("form");
      
      $this.find(".sib_msg_disp").hide();
      
      var email = $this.find('input.sib-email-area').val();
      var klaviyo_list_id = $this.find('[name="klaviyo_list_id"]').val();
      
      var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,16})?$/;
      
      if(email == '' || !emailReg.test(email)) {
        $this.find(".sib_msg_disp").html('<h6 style="color:#fff;">Please provide a valid email address</h6>').show();
        return;
      }
      
      var errors = 0;
      
      $this.find('input').each(function() {
        if($(this).prop('required') && $(this).val() == '') {
          $this.find(".sib_msg_disp").html('<h6 style="color:#fff;">Please fill out all required fields</h6>').show();
          errors++;
        }
      });
      
      if(errors > 0)
        return;
      
      if(typeof grecaptcha === "object") {
      
        grecaptcha.ready(function() {
          grecaptcha.execute('6LdgGC4gAAAAANuuHvRlf7bFSBZHccadtzjWfkS0', {action: 'submit'}).then(function(token) {
        
            $.ajax({
              method: "POST",
              dataType: 'json',
              url: theme_vars.ajaxurl,
              data: {
                action: "send_to_klaviyo",
                email: email,
                recaptcha_token: token,
                klaviyo_list_id: klaviyo_list_id,
              },
              beforeSend: function(response) {
                $this.find(".sib_msg_disp").html('<h6 style="color:#fff;">Please wait...</h6>').show();
              },
              success: function(response) {
                $(".sib_msg_disp").hide();
                $(".success_message").show();
                $('[data-hide-on-success]').hide();
                
                var d = new Date();
                d.setTime(d.getTime() + (365*24*60*60*1000));
                var expires = "expires="+ d.toUTCString();
                document.cookie = 'webinar-form-submitted-' + window.location.href + "=" + '1' + ";" + expires + ";path=/";
              },
              error: function(response) {
                console.log(response);
              }
            });
              
          });
        });
        
      }
      else {
        
        $.ajax({
          method: "POST",
          dataType: 'json',
          url: theme_vars.ajaxurl,
          data: {
            action: "send_to_klaviyo",
            email: email,
            klaviyo_list_id: klaviyo_list_id,
          },
          beforeSend: function(response) {
            $this.find(".sib_msg_disp").html('<h6 style="color:#fff;">Please wait...</h6>').show();
          },
          success: function(response) {
            $(".sib_msg_disp").hide();
            $(".success_message").show();
            $('[data-hide-on-success]').hide();
            
            var d = new Date();
            d.setTime(d.getTime() + (365*24*60*60*1000));
            var expires = "expires="+ d.toUTCString();
            document.cookie = 'webinar-form-submitted-' + window.location.href + "=" + '1' + ";" + expires + ";path=/";
          },
          error: function(response) {
            console.log(response);
          }
          
        });
        
      }
      
    });
  
    $('#sib_signup_form_1 [type="submit"], #sib_signup_form_2 [type="submit"], #sib_signup_form_3 [type="submit"]').click(function(e) {
      
      e.preventDefault();
      
      var $this = $(this).closest("form");
      
      $this.find(".sib_msg_disp").hide();
      
      var email = $this.find('input.sib-email-area ').val();
      
      var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,16})?$/;
      
      if(email == '' || !emailReg.test(email)) {
        $this.find(".sib_msg_disp").html('<h6 style="color:#fff;">Please provide a valid email address</h6>').show();
        return;
      }
      
      if(typeof grecaptcha === "object") {
      
        grecaptcha.ready(function() {
          grecaptcha.execute('6LdgGC4gAAAAANuuHvRlf7bFSBZHccadtzjWfkS0', {action: 'submit'}).then(function(token) {
        
            $.ajax({
              method: "POST",
              dataType: 'json',
              url: theme_vars.ajaxurl,
              data: {
                action: "send_to_klaviyo",
                email: email,
                klaviyo_list_id: 'PHvRHr',
              }
            });
            
            $.ajax({
              method: "POST",
              dataType: 'json',
              url: theme_vars.ajaxurl,
              data: {
                action: "send_to_klaviyo",
                email: email,
                recaptcha_token: token,
                klaviyo_list_id: 'XHzwZd',
              },
              beforeSend: function(response) {
                $this.find(".sib_msg_disp").html('<h6 style="color:#fff;">Please wait...</h6>').show();
              },
              success: function(response) {
                $this.find(".sib_msg_disp").html('<h6 style="color:#fff;">Thank you for subscribing!</h6>').show();
                $this.find('fieldset, .agree_with_terms, .field-area').hide();
              },
              error: function(response) {
                console.log(response);
              }
              
            });
            
            
          });
        });
        
      }
      else {
        
        $.ajax({
          method: "POST",
          dataType: 'json',
          url: theme_vars.ajaxurl,
          data: {
            action: "send_to_klaviyo",
            email: email,
            klaviyo_list_id: 'PHvRHr',
          }
        });
        
        $.ajax({
          method: "POST",
          dataType: 'json',
          url: theme_vars.ajaxurl,
          data: {
            action: "send_to_klaviyo",
            email: email,
            klaviyo_list_id: 'XHzwZd',
          },
          beforeSend: function(response) {
            $this.find(".sib_msg_disp").html('<h6 style="color:#fff;">Please wait...</h6>').show();
          },
          success: function(response) {
            $this.find(".sib_msg_disp").html('<h6 style="color:#fff;">Thank you for subscribing!</h6>').show();
            $this.find('fieldset, .agree_with_terms, .field-area').hide();
          },
          error: function(response) {
            console.log(response);
          }
          
        });
        
      }
      
    });
    
     $("main .webinar_form").each(function() {
      
      var $webinar_form = $(this);
      
      if(($webinar_form).length) {
        
        if(getCookie('webinar-form-submitted-' + window.location.href) == 1) {
          $webinar_form.find(".success_message").show();
          $webinar_form.find('[data-hide-on-success]').hide();
        }
    
      }
      
    });
    
    $("body").on("click", ".number .minus", function() {
      
      var $input = $(this).parent().find('input');
      var count = parseInt($input.val()) - 1;
      
      if($(this).parent().hasClass('positive'))
        count = count < 1 ? 1 : count;
      else
        count = count < 0 ? 0 : count;

      $input.val(count);
      $input.change();
      
      return false;
      
    });
    
     $("body").on("click", ".number .plus", function() {
      
      var $input = $(this).parent().find('input');
      var count = parseInt($input.val()) + 1;
      
      $input.val(count);
      $input.change();
      
      return false;
      
    });
    
    $("body").on("change", ".number input", function(e) {
      
      e.preventDefault();
       
      if($(this).parent().hasClass('positive')) {
        if($(this).val() < 1)
          $(this).val(1);
      }
      else {
        if($(this).val() < 0)
          $(this).val(0);
      }
      
      return false;
      
    });
    

  });
  
}


// WEBPACK FOOTER //
// ./assets/js/modules/forms.js